    // paypal.strategy.ts
import { Injectable } from '@angular/core';
import { PaymentStrategy, PaymentResult } from '../payment-strategy.interface';
// import { paypalService } from '../services/paypal.service';
import { PaymentApiService } from '../services/payment-api.service';


@Injectable()
export class PaypalStrategy implements PaymentStrategy {
  constructor(

    // private paypalService: paypalService,
    private paymentApiService: PaymentApiService) {}

  async initialize(config: { applicationId: string; locationId: string }): Promise<boolean> {
    // Inicializa el SDK de paypal con las credenciales
    // return await this.paypalService.initializepaypal();
    return;
  }

  async renderPaymentForm(containerId: string): Promise<boolean> {
    // Renderiza el formulario de tarjeta de paypal
    // return await this.paypalService.createCard(containerId);
    return;
  }

  async processPayment(amount: number, metadata: any): Promise<PaymentResult> {
     try {
    // 1. Tokenizar la tarjeta
    // const nonce = await this.paypalService.tokenizeCard();
    // if (!nonce) {
    //   return { success: false, error: 'Error al tokenizar la tarjeta' };
    // }
// console.log(nonce)
console.log(metadata)
    // 2. Preparar el payload específico para paypal
    const paypalPayload = {
      paymentMethods: [{
                payment_methods_id: 2, // Obligatorio para Plataformas de pago
                total_amount: metadata.total_amount,
                amount_payment: metadata.amount_payment,
                currency: metadata.currency,
                agent_id: metadata.agent_id,
                client_id: metadata.client_id,
                agency_id: metadata.agency_id,
                itinerary_id: metadata.itinerary_id,
                user_id_create: metadata.agent_id,
                currency_payment: metadata.currency,
                // nonce: nonce,
                payment_platform_id: 1, // Obligatorio para paypal
                paymentMasterDetails: metadata.payloadDetails
      }]
    };

    console.log(paypalPayload);

    const payloadDataPaymentCreditCard = {
            payment_masters_id: '',
            payment_id: metadata.dataPaymentCreditCard.id,
            payer_id: metadata.dataPaymentCreditCard.payer_id,
            payer_name: metadata.dataPaymentCreditCard.payer_name,
            payer_email: metadata.dataPaymentCreditCard.email,
            amount: metadata.total_amount,
            products:  metadata.payloadDetails,
            status: 'APROVEE',
            currency: metadata.currency,
            agent_id: metadata.agent_id,
            agency_id: metadata.agency_id,
            itinerary_id: metadata.itinerary_id
    };

    const responseSavePaymentCreditCard = await this.paymentApiService.savePaymetCreditsCards(payloadDataPaymentCreditCard);

    console.log(responseSavePaymentCreditCard);

    if(responseSavePaymentCreditCard.success) {
      const response = await this.paymentApiService.createPayment(paypalPayload);
  console.log('de vuelta luego de mandar a back', response)
       return {
          success: response.success,
          message: response.message
        };
    } else {
      return {
        success: false,
        message: 'Hubo un error al crear el pago con la tarjeta de crédito'
      }
    }

    } catch (error: any) {
      console.error('❌ Error en paypalStrategy:', error);
      return {
        success: false,
        error: error.message || 'Error procesando pago'
      };
    }

  }


}
